import styled from 'styled-components';

const Links = styled.div`
  margin-top: 19px;
`;

export default Links;
